import React, { useEffect } from 'react';
import * as Yup from 'yup';
import IncrementDecrement from '../../../../../../newComponents/IncrementDecrement';
import Radio from '../../../../../../newComponents/Radio';

import Input from '../../../../../../newComponents/UnformInput';

import { useComplements } from '../../../../../../hooks/complements';

import { Container, Options, OptionContent } from './styles';

export const DetailsFormSchema = Yup.object().shape({
  name: Yup.string()
    .max(40, 'No máximo 40 caracteres')
    .required('O nome é obrigatório'),
});

const Details: React.FC = () => {
  const {
    name,
    maximumQuantity,
    minimumQuantity,
    isRequired,
    handleChangeComplement,
  } = useComplements();

  useEffect(() => {
    if (
      typeof maximumQuantity === 'undefined' &&
      typeof minimumQuantity === 'undefined'
    ) {
      handleChangeComplement({ maximumQuantity: 1, minimumQuantity: 0 });
    }
  }, [maximumQuantity, minimumQuantity, handleChangeComplement]);

  return (
    <Container>
      <Input
        id="name"
        name="name"
        label="Nome do grupo de complementos"
        placeholder="Ex.: Adicionais"
      />
      <div className="requirement">
        <div className="header">
          <h3>Obrigatoriedade</h3>
          <p>
            Indique se essa categoria de complementos é necessária para todos os
            pedidos
          </p>
        </div>
        <Options>
          <Radio
            checked={!isRequired}
            value="false"
            name="requirement"
            onChange={() =>
              handleChangeComplement({ isRequired: false, minimumQuantity: 0 })
            }
          >
            <OptionContent>
              <strong>Opcional</strong>
              <span>O cliente pode ou não selecionar esse item</span>
            </OptionContent>
          </Radio>
          <Radio
            checked={isRequired}
            value="true"
            name="requirement"
            onChange={() =>
              handleChangeComplement({
                isRequired: true,
                minimumQuantity:
                  (minimumQuantity ?? 0) < 1 ? 1 : minimumQuantity,
              })
            }
          >
            <OptionContent>
              <strong>Obrigatório</strong>
              <span>
                O cliente deve selecionar 1 ou mais itens para adicionar o
                pedido ao carrinho
              </span>
            </OptionContent>
          </Radio>
        </Options>
      </div>
      <div className="quantity">
        <div className="header">
          <h3>Quantidade</h3>
          <p>Indique quantos itens podem ser selecionados</p>
        </div>
        <div className="values">
          <IncrementDecrement
            id="min"
            label="Mínimo"
            value={minimumQuantity ?? 0}
            min={isRequired ? 1 : 0}
            max={!isRequired ? 0 : maximumQuantity ?? 0}
            onChangeValue={(value) =>
              handleChangeComplement({ minimumQuantity: value })
            }
          />
          <IncrementDecrement
            id="max"
            label="Máximo"
            value={maximumQuantity ?? 1}
            min={minimumQuantity ?? 0}
            onChangeValue={(value) =>
              handleChangeComplement({ maximumQuantity: value })
            }
          />
        </div>
      </div>
    </Container>
  );
};

export default Details;
